/* src/components/download-pdf-modal/download-pdf-modal.component.scss */
.download-pdf--proposals {
  margin-left: 0.8rem;
}
/*# sourceMappingURL=download-pdf-modal.component-IDRFZQU7.css.map */
